import React from 'react';

const defaultSuggestions = [
  'Product Managers at Meta',
  'Data Scientists in San Francisco',
  'Investment Banking Associates',
  'UX Designers at Startups',
];

const defaultUniversities = [
  { id: 'ucsb', name: 'UCSB' },
  { id: 'ucb', name: 'UC Berkeley' },
  { id: 'ucla', name: 'UCLA' },
  { id: 'uci', name: 'UC Irvine' },
  { id: 'santa_clara', name: 'Santa Clara' },
];

const SearchSection = ({
  isSignedIn,
  query,
  lastSearchQuery,
  suggestions = defaultSuggestions,
  universities = defaultUniversities,
  selectedUniversities = [],
  onQueryChange,
  onSubmit,
  onQuickSearch = () => {},
  onToggleUniversity = () => {},
}) => {

  if (!isSignedIn) return null;

  return (
    <div className="bg-[#242831] rounded-lg p-6 mb-6 shadow-lg">
      <form onSubmit={onSubmit} className="mb-4">
        <input
          type="text"
          className="w-full px-4 py-3 bg-[#2d3139] border border-[#374151] rounded-lg text-[#e4e6eb] text-sm focus:outline-none focus:border-[#10b981]"
          placeholder="Search by company, position, industry..."
          value={query}
          onChange={e => onQueryChange(e.target.value)}
        />
      </form>

      {lastSearchQuery && (
        <div className="bg-[#2d3139] px-4 py-3 rounded-lg mb-4 text-sm text-[#9ca3af]">
          <strong className="text-[#e4e6eb]">Searched for:</strong> "{lastSearchQuery}"
        </div>
      )}

      <div className="text-center">
        <div className="text-[#9ca3af] text-sm mb-2">Try searching for:</div>
        <div className="flex flex-wrap justify-center gap-2">
          {suggestions.map(text => (
            <button
              key={text}
              type="button"
              onClick={() => onQuickSearch(text)}
              className="px-3 py-1.5 bg-[#374151] text-[#e4e6eb] rounded-full text-xs hover:bg-[#4b5563] transition-all hover:-translate-y-0.5"
            >
              {text}
            </button>
          ))}
        </div>
      </div>

      {universities.length > 0 && (
        <div className="mt-8 mb-2 text-center">
          <div className="text-[#9ca3af] text-sm mb-3">Filter by university:</div>
          <div className="flex flex-wrap justify-center gap-2 items-center">
            {universities.map(university => (
              <button
                key={university.id}
                type="button"
                onClick={() => onToggleUniversity(university.id)}
                className={`px-4 py-2 rounded text-sm font-medium transition-all ${
                  selectedUniversities.includes(university.id)
                    ? 'bg-[#10b981] text-white'
                    : 'bg-[#374151] text-[#e4e6eb] hover:bg-[#4b5563]'
                }`}
              >
                {university.name}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export { SearchSection };
